import { useFormik } from "formik";
import { useEffect, useState } from "react";
import axiosCelestine from "../../../../../config/AxiosCelestine";
import AsyncSelect from "react-select/async";
import { useHistory, useParams } from "react-router-dom";
import * as Yup from "yup";

//components
import ErrorHandler from "../../../../../components/toast/ErrorHandler";
import Input from "../../../../../components/input/Input";

export interface CategoryToBrandProps {}

const CategoryToBrand: React.FC<CategoryToBrandProps> = () => {
  const history = useHistory();
  const params: {
    id: string;
    detail: string;
  } = useParams();
  const [posted, setPosted] = useState(true);
  const [productDetail, setproductDetail] = useState<any>(null);
  const [productCategory, setProductCategory] = useState<any>({
    label: "Select here",
    values: "",
  });
  const [productBrand, setProductBrand] = useState<any>({
    label: "Select here",
    values: "",
  });

  const { values, setValues, handleSubmit, errors, touched } = useFormik({
    initialValues: {
      product_brand_id: "",
      product_category_id: "",
      special_category_id: "",
      type: "product_category_to_brand",
      published: true,
    },
    validationSchema: Yup.object({
      product_brand_id: Yup.string().required(
        "Detail categories brand / sub-brand is required!"
      ),
      product_category_id: Yup.string().required(
        "Product category is required!"
      ),
    }),
    onSubmit: (values) => {
      values.special_category_id = params.detail;

      const new_product_brand = new FormData();
      new_product_brand.append(
        "special_category_id",
        values.special_category_id
      );
      new_product_brand.append("product_brand_id", values.product_brand_id);
      new_product_brand.append("published", values.published.toString());
      new_product_brand.append("type", values.type);

      if (productBrand.values) {
        new_product_brand.append(
          "product_brand_id",
          productBrand.values.toString()
        );
      } else {
        ErrorHandler("error", "Please input product brand!");
      }

      new_product_brand.append(
        "product_category_id",
        values.product_category_id
      );

      axiosCelestine()
        .post("admin/special-category-list", new_product_brand)
        .then(({ data }) => {
          ErrorHandler("#00C62E", "Add Completed");
          setTimeout(() => {
            history.push(
              `/marketplace/product-category-group/categories/${params.id}/detail-categories/${params.detail}`
            );
          }, 1500);
        })
        .catch((err) => ErrorHandler("#DF5354", err.response.data.errors));
    },
  });

  const handlePost = () => {
    setPosted(!posted);
    values.published = !values.published;
  };

  const loadProductBrand = async (inputValue: string) => {
    try {
      const { data } = await axiosCelestine().get("admin/product-brand", {
        params: {
          name: inputValue,
          limit: 30,
        },
      });
      const option = data.data.map((el: any) => ({
        label: el.name,
        values: el.id,
      }));
      return option;
    } catch (err) {
      console.log(err);
    }
  };

  const loadProductCategory = async (inputValue: string) => {
    try {
      const { data } = await axiosCelestine().get("admin/product-category", {
        params: {
          name: inputValue,
          limit: 30,
        },
      });
      const option = data.data.map((el: any) => ({
        label: el.name,
        values: el.id,
      }));
      return option;
    } catch (err) {
      console.log(err);
    }
  };

  const getProductBrandImg = () => {
    const id = productBrand?.values;
    axiosCelestine()
      .get(`admin/product-brand/${id}`)
      .then(({ data }) => {
        setproductDetail(data);
      })
      .catch((err) => {
        return null;
      });
  };

  useEffect(() => {
    getProductBrandImg();
  }, [productBrand]);

  const handleChangeBrand = (brand: any) => {
    setProductBrand(brand);
  };

  const handleChangeCategory = (ctgry: any) => {
    setProductCategory(ctgry);
  };

  useEffect(() => {
    setValues({ ...values, product_brand_id: productBrand.values });
  }, [productBrand]);

  useEffect(() => {
    setValues({ ...values, product_category_id: productCategory.values });
  }, [productCategory]);

  return (
    <form
      onSubmit={handleSubmit}
      className="w-full h-full mt-8 md:flex justify-between"
    >
      {/* form image */}
      <div className="md:w-1/3 h-full rounded-md border-2 border-stroke">
        <div className="md:h-16 h-14 flex items-center md:mx-6 mx-5">
          <h1 className="font-medium md:text-lg text-base">
            Detail Category Images
          </h1>
        </div>
        <hr />

        <div className="md:mx-6 mx-5 mt-7">
          <div className="my-6">
            <h1 className="md:text-sm text-textPrimary">Display Image</h1>
            {productDetail !== null ? (
              <div className="flex justify-center">
                <img
                  src={productDetail.image_path}
                  alt="no images uploaded"
                  className="w-44 mt-7 font-rom text-sm"
                />
              </div>
            ) : (
              <h1 className="mt-3 text-primary">Please Select Brand!</h1>
            )}
          </div>
        </div>
      </div>

      {/* form information */}

      <div className="md:w-custom h-full md:mt-0 mt-8">
        <div className="rounded-md rounded-b-none border-2 border-stroke">
          <div className="h-16 flex items-center justify-between md:mx-6 mx-5">
            <h1 className="font-medium md:text-lg text-base">
              Detail Category Information
            </h1>

            <div className="flex">
              <h1 className="font-medium md:text-base text-sm mr-3 text-textPrimary">
                Posted
              </h1>
              <div className="flex justify-between items-center">
                <div
                  className={
                    posted
                      ? "md:w-8 md:h-4 flex items-center rounded-full p-1 duration-300 ease-in-out bg-primary"
                      : "md:w-8 md:h-4 flex items-center rounded-full p-1 duration-300 ease-in-out bg-gray-500"
                  }
                >
                  <div
                    className={
                      posted
                        ? "bg-white  md:w-3 md:h-3 rounded-full shadow-md transform duration-300 ease-in-out cursor-pointer md:translate-x-3 translate-x-3"
                        : "bg-white md:w-3 md:h-3 rounded-full shadow-md transform duration-300 ease-in-out cursor-pointer"
                    }
                    onClick={handlePost}
                  ></div>
                </div>
              </div>
            </div>
          </div>
          <hr />

          <div className="md:flex w-full mb-8">
            <div className="md:mx-6 mx-5 mt-7 md:w-full">
              <div>
                <h1 className="md:text-base text-sm text-textPrimary">
                  Detail Categories Brand / Sub-Brand
                </h1>
                <AsyncSelect
                  cacheOptions
                  defaultOptions
                  loadOptions={loadProductBrand}
                  onChange={handleChangeBrand}
                  className="my-3 font-rom text-sm"
                />
                {touched.product_brand_id && errors.product_brand_id ? (
                  <p className="text-primary">{errors.product_brand_id}</p>
                ) : null}
              </div>
              <div className="mt-4">
                <h1 className="md:text-base text-sm text-textPrimary">
                  Product Category
                </h1>
                <AsyncSelect
                  cacheOptions
                  defaultOptions
                  loadOptions={loadProductCategory}
                  onChange={handleChangeCategory}
                  className="my-3 font-rom text-sm"
                />
                {touched.product_category_id && errors.product_category_id ? (
                  <p className="text-primary">{errors.product_category_id}</p>
                ) : null}
              </div>
              <div className="mt-4">
                <h1 className="md:text-base text-sm text-textPrimary">
                  Detail Categories Name (From Brand)
                </h1>
                <Input
                  type={"text"}
                  disable={true}
                  placeholder="Place Holder"
                  name="name"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="rounded-md rounded-t-none border-2 border-t-0 border-stroke flex w-full md:h-18 h-16 mb-10">
          <div className="w-1/2 flex items-center justify-center border-r-2 border-stroke ">
            <button type="reset" className="focus:outline-none">
              <h1 className="md:text-base text-base cursor-pointer hover:text-primary">
                Clear
              </h1>
            </button>
          </div>
          <div className="w-1/2 flex items-center justify-center">
            <button type="submit" className="focus:outline-none">
              <h1 className="md:text-base text-base cursor-pointer hover:text-primary">
                Save
              </h1>
            </button>
          </div>
        </div>
      </div>
    </form>
  );
};

export default CategoryToBrand;
